/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.2.16",
    versionName: "0.2.0-nightly.2026.2.16",
    versionChannel: "nightly",
    buildDate: "2026-02-16T00:10:18.217Z",
    commitHash: "2818d8868cb212154787316b6a3e18d0413987ef",
};
